// Real client quotes only, used with each client's permission.
// Format: { quote: "...", name: "Marcus T.", location: "Atlanta, GA", rating: 5 }
// The homepage strip stays hidden while this list is empty.
export const TESTIMONIALS = [];
